import React from "react";
import { Link } from "react-router-dom";

export default function EmployerProfileReadOnly({
  employer,
  showActions = false,
  onMessage,
  onRefer
}) {
  if (!employer) return null;

  return (
    <div className="employerProfileReadOnly">

      <div className="clientDetailHeader">

        <div>
          <h2>{employer.companyName || "Employer"}</h2>
          <p>{employer.industry || ""}</p>
        </div>

        {employer.logoUrl && (
          <img
            src={employer.logoUrl}
            alt=""
            className="employerLogo"
          />
        )}

      </div>

      <div className="clientInfoGrid">

        <div>
          <strong>Website</strong>
          <p>
            {employer.website ? (
              <a
                href={employer.website}
                target="_blank"
                rel="noreferrer"
              >
                {employer.website}
              </a>
            ) : "Not provided"}
          </p>
        </div>

        <div>
          <strong>Location</strong>
          <p>
            {[employer.city, employer.province]
              .filter(Boolean)
              .join(", ")}
          </p>
        </div>

        <div>
          <strong>Hiring Regions</strong>
          <p>{employer.hiringRegions || "Not provided"}</p>
        </div>

        <div>
          <strong>Remote Available</strong>
          <p>{employer.remoteAvailable ? "Yes" : "No"}</p>
        </div>

        <div>
          <strong>Primary Contact</strong>
          <p>{employer.contactName || "Not provided"}</p>
        </div>

        <div>
          <strong>Email</strong>
          <p>{employer.email || "Not provided"}</p>
        </div>

        <div>
          <strong>Phone</strong>
          <p>{employer.phone || "Not provided"}</p>
        </div>

        <div>
          <strong>Industry</strong>
          <p>{employer.industry || "Not provided"}</p>
        </div>

      </div>

      <section className="coachPanel">

        <h3>Company Description</h3>

        <div className="coachResumeViewer">

          <pre>
            {employer.companyDescription || "No description provided."}
          </pre>

        </div>

      </section>

      {showActions && (

        <div className="publicProfileActions">

          <button onClick={onMessage}>
            Message Employer
          </button>

          <button
            className="secondary"
            onClick={onRefer}
          >
            Refer Selected Client
          </button>

          <Link
            className="secondaryButton"
            to={`/employers/${employer.id}`}
          >
            Public Employer Page
          </Link>

        </div>

      )}

    </div>
  );
}